import { Step2FormModel } from './model'

export const getInitialValues = (consentTypes: string[]): Step2FormModel => ({
	code: '',
	consentTypes: consentTypes.reduce((acc, curr) => {
		acc[curr] = true
		return acc
	}, {} as Step2FormModel['consentTypes']),
})
